<template>
  <div id="app">
    <router-view />
    
  </div>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  methods: {
  }
}
</script>
<style lang="less">
#app {
  min-height: 100vh;
  background-color: #eeecec;
}
</style>
